import { FieldsLayout } from "./layout";
import AutoDiscoveryContent from "../auto-discovery";

const AutoDiscoveryPage = () => {
  return (
    <FieldsLayout>
      <AutoDiscoveryContent />
    </FieldsLayout>
  );
};

export default AutoDiscoveryPage;
